//Note: these colors will not directly match the hex codes on the React side.
//These are non-linear color definitions which are then gamma-corrected by WebGL.

export const WORKSPACE_BKG_COLOR = 0xB5B4AE;
export const WORKSPACE_GRID_COLOR = 0x474642;
export const PRIMARY_HIGHLIGHT_COLOR = 0x15c663;
export const SECONDARY_HIGHLIGHT_COLOR = 0xc8ded5;
